import { render, staticRenderFns } from "./leaveRequest.vue?vue&type=template&id=5e70d166&scoped=true&"
import script from "./leaveRequest.vue?vue&type=script&lang=js&"
export * from "./leaveRequest.vue?vue&type=script&lang=js&"
import style0 from "./leaveRequest.vue?vue&type=style&index=0&id=5e70d166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e70d166",
  null
  
)

export default component.exports